"use strict";
/* globals module */
/**
 * @module userProfileAvatarStreamsRoute
 * @description Baasic User Profile Avatar Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
var contracts_1 = require("../../core/contracts");
var UserProfileAvatarStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileAvatarStreamsRoute, _super);
    function UserProfileAvatarStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'profiles/{id}/avatar-streams/{?width,height,t}';
        _this.createRoute = 'profiles/{id}/avatar-streams/{filename}';
        _this.updateRoute = 'profiles/{id}/avatar-streams/{?width,height}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of profile. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @example userProfileAvatarStreamsRoute.get({id: '<file-id>'});
     **/
    UserProfileAvatarStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved as well with id of the profile.
     * @method
     * @example userProfileAvatarStreamRoute.create({ filename: '<filename>', id: '<file-id>' });
     **/
    UserProfileAvatarStreamsRoute.prototype.create = function (id, data) {
        if (!this.utility.isObject(data)) {
            data = {
                filename: data
            };
        }
        var params = this.utility.extend({}, data);
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.createRoute, params);
    };
    /**
     * Parses update route; this route should be expanded with the id of the profile. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param data
     * @example userProfileAvatarStreamsRoute.update({id: '<file-id>'});
     **/
    UserProfileAvatarStreamsRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.updateRoute, data);
    };
    var _a;
    UserProfileAvatarStreamsRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserProfileAvatarStreamsRoute);
    return UserProfileAvatarStreamsRoute;
}(common_1.BaseRoute));
exports.UserProfileAvatarStreamsRoute = UserProfileAvatarStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
